module.exports = __webpack_public_path__ + "static/media/paymentpage_total.a68cdb1e.png";